<template>
  <base-layout toolbarActive toolbarClass="content-bg--3">
    <template #toolbarBase>
      <div class="display-2 font-weight-bold text-xs-center">
        Тех. поддержка
      </div>
    </template>

    <support-form tabs></support-form>
  </base-layout>
</template>

<script>
import BaseLayout from "../components/layout/BaseLayout.vue";
import SupportForm from "../components/support/SupportForm.vue";

export default {
  name: "SupportView",

  components: {
    BaseLayout,
    SupportForm
  },

  data: () => ({}),

  mounted() {},

  computed: {}
};
</script>
